import * as RolePermissionConstants from "../constants/RolePermissionConstants";

export const getUserRolePermission = (sectionName, fieldName) => {
  try {
    if (sectionName && fieldName) {
      const roles = JSON.parse(
        localStorage.getItem(RolePermissionConstants.ROLES)
      );
      if (roles && roles.rolePermissions) {
        const permissionKey = sectionName + "_" + fieldName + "_";
        if (
          roles.rolePermissions.includes(
            permissionKey + RolePermissionConstants.EDIT
          )
        ) {
          return RolePermissionConstants.EDIT;
        } else if (
          roles.rolePermissions.includes(
            permissionKey + RolePermissionConstants.VIEW
          )
        ) {
          return RolePermissionConstants.VIEW;
        } else {
          return RolePermissionConstants.NONE;
        }
      } else {
        throw new Error("Permissions for the logged in user not assigned.");
      }
    } else {
      throw new Error(
        "The parameter type must be sting which will identify the page name or field name."
      );
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * Common function to manage cases to check User Role Access for different functions
 */
export const verifyAccessPermission = (permissionName) => {
  let permCondition = false;
  switch (permissionName) {
    case "manageUsersView":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_USERMANAGEMENT_MANAGEUSERS,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.VIEW;
      break;
    case "manageUsersAddUserEdit":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_USERMANAGEMENT_ADDUSER,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.EDIT;
      break;
    case "manageUsersParentChildDunsView":
      let userPerm = getUserRolePermission(
        RolePermissionConstants.VENDORPLATFORM_USERMANAGEMENT_PARENTCHILDDUNS,
        RolePermissionConstants.ALL
      );
      permCondition = [
        RolePermissionConstants.VIEW,
        RolePermissionConstants.EDIT,
      ].includes(userPerm);
      break;
    case "manageUsersParentChildDunsEdit":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_USERMANAGEMENT_PARENTCHILDDUNS,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.EDIT;
      break;
    case "initialAddressPopup":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_VENDORONBOARDING_EXTERNALUSERCHECK,
          RolePermissionConstants.INITIALADDRESSPOPUP
        ) === RolePermissionConstants.EDIT;
      break;
    case "extUserEnabled":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_VENDORONBOARDING_EXTERNALUSERCHECK,
          RolePermissionConstants.EXTUSERENABLED
        ) === RolePermissionConstants.VIEW;
      break;
    case "viewRightNotes":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_NOTES_RIGHTNOTES,
          RolePermissionConstants.VMP_SIDEBARPANEL
        ) === RolePermissionConstants.VIEW;
      break;
    case "manageUsersSellerSendEmail":
      permCondition =
        getUserRolePermission(
          RolePermissionConstants.VENDORPLATFORM_USERMANAGEMENT_MANAGEUSERS_SEND_EMAIL,
          RolePermissionConstants.ALL
        ) === RolePermissionConstants.VIEW;
      break;
    default:
      break;
  }
  if (permCondition) {
    return true;
  }
  return false;
};
